import api from './axios';

const benefitRequest = async () => {
  try {
    const { data } = await api.get('benefit');
    return data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    throw error.response.data ? error.response.data : error.response;
  }
};

export default {
  benefitRequest,
};
